var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalViolations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#749BC5",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.705 6.605c0 1.382-1.133 2.502-2.53 2.502-1.398 0-2.531-1.12-2.531-2.502 0-1.381 1.133-2.502 2.53-2.502 1.398 0 2.53 1.12 2.53 2.502M19.25 10.304c0 1.382-1.133 2.502-2.53 2.502-1.398 0-2.531-1.12-2.531-2.502 0-1.382 1.133-2.502 2.53-2.502 1.398 0 2.531 1.12 2.531 2.502M16.72 13.857c-.87 0-1.705.342-2.32.95a3.224 3.224 0 0 0-.96 2.293v3.063H20V17.1c0-.86-.346-1.685-.96-2.293a3.299 3.299 0 0 0-2.32-.95zM10.827 9.721 8.68 11.852 4.1 10.298a3.58 3.58 0 0 0-.82-.084 3.3 3.3 0 0 0-2.32.95A3.225 3.225 0 0 0 0 13.458v6.709h6.56v-6.713c0-.04-.01-.078-.011-.118l2.07.703a1.062 1.062 0 0 0 1.09-.251l2.614-2.594a1.038 1.038 0 0 0 .01-1.489 1.062 1.062 0 0 0-1.505.016h-.001zM8.19 3.181 9.67.167l1.139.547-1.48 3.014zM9.812 5.62l3.983-.92.289 1.22-3.983.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalViolations);
export default __webpack_public_path__ + "static/media/total-violations.051cb730840afc265960ac8874aac4c4.svg";
export { ForwardRef as ReactComponent };